<template>
    <CCard class="order-ed-card">
        <CCardHeader>
            <strong>Подробности заказа</strong>
        </CCardHeader>
        <CCardBody>
            <CTabs variant="tabs" :active-tab="0">
                <CTab title="Карточка" class="pt-1">
                    <div v-if="orderUnmodified.cutlery" class="flex items-center my-2">
                        <span class="w-1/3">Приборы</span>
                        <span class="w-2/3">{{ orderUnmodified.cutlery }}</span>
                    </div>
                    <CDataTable
                        hover
                        :items="enabledUnmodifiedItems"
                        :fields="unmodifiedFields"
                    >
                        <template #entity="data">
                            <td>
                                <CLink
                                    :to="`/entities/${data.item.entity.entityType.code}/${data.item.entity.id}/`"
                                >{{ data.item.entity.title }}</CLink
                                >
                            </td>
                        </template>

                        <template #entity_product="data">
                            <td>
                                <CLink
                                    :to="`/entities/${data.item.entity.entityType.code}/${data.item.entity.id}/products/${data.item.entity_product.id}`"
                                >{{
                                    data.item.entity_product_title
                                        ? data.item.entity_product_title
                                        : data.item.entity_product.title
                                }}</CLink
                                >
                            </td>
                        </template>

                        <template #entity_product_price="data">
                            <td>
                                {{ data.item.entity_product_price }}
                                <span v-if="data.item.old_entity_product_price"><span class="old-price">({{ data.item.old_entity_product_price }})</span></span> р.
                            </td>
                        </template>

                        <template #variants="data">
                            <td>
                                <span
                                    v-for="variant in data.item.entity_variants"
                                    :key="variant.title"
                                >
                                    {{ variant.title }} -
                                    {{ variant.price }}
                                    <span v-if="variant.old_price"><span class="old-price">({{ variant.old_price }}</span> р.)</span><br />
                                </span>
                            </td>
                        </template>

                        <template #options="data">
                            <td>
                                <span
                                    v-for="option in data.item.entity_options"
                                    :key="option.title"
                                >
                                    {{ option.title }} -
                                    {{ option.price }}
                                    <span v-if="option.old_price"><span class="old-price">({{ option.old_price }}</span> р.)</span><br />
                                </span>
                            </td>
                        </template>

                        <template #price="data">
                            <td>
                                {{ formatPrice(data.item.price) }}
                                <span v-if="data.item.price && data.item.old_price && +data.item.price != +data.item.old_price">
                                    <span class="old-price">({{ formatPrice(data.item.old_price) }})</span>
                                </span>
                            </td>
                        </template>

                        <template #quantity="data">
                            <td>
                                {{ data.item.quantity }}
                            </td>
                        </template>

                        <template #price_total="data">
                            <td :class="{'red': data.item.not_added && (data.item.price != data.item.price_total), 'green': !data.item.not_added}">
                                {{ formatPrice(data.item.price_total) }}
                                <span v-if="data.item.price_total && data.item.old_price_total && +data.item.price_total != +data.item.old_price_total">
                                    <span class="old-price">({{ formatPrice(data.item.old_price_total) }})</span>
                                </span>
                            </td>
                        </template>

                        <template #quantity_total="data">
                            <td
                                :style="+data.item.quantity_total > 1 ? 'font-size: 200%' : ''"
                                :class="{'red': data.item.not_added && (data.item.quantity != data.item.quantity_total), 'green': !data.item.not_added}">
                                {{ data.item.quantity_total }}
                            </td>
                        </template>


                        <template #refund_for="data">
                            <td>
                                {{
                                    data.item && data.item.refund_for
                                        ? ` За счет ${data.item.refund_for}${data.item.refund_comment ? ' ('+data.item.refund_comment+')' : ''} - ${ formatPrice(data.item.refund_sum) }`
                                        : ''
                                }}
                            </td>
                        </template>

                        <template #sum="data">
                            <td>
                                {{ formatPrice(data.item.sum) }}
                            </td>
                        </template>

                        <template #sum_total="data">
                            <td class="blue">
                                {{ formatPrice(data.item.sum_total) }}
                            </td>
                        </template>

                        <template #edit> </template>
                    </CDataTable>
                </CTab>
                <CTab title="Редактировать" class="pt-1">
                    <CRow>
                        <CCol sm="4" class="form-group pt-1">Приборы</CCol>
                        <CCol sm="8" class="form-group">
                            <CInput
                                v-model="order.cutlery"
                                class="m-0"
                                type="number"
                            />
                        </CCol>
                    </CRow>

                    <CDataTable
                        hover
                        :items="enabledItems"
                        :fields="fields">
                        <template #entity="data">
                            <td>
                                <CLink
                                    :to="`/entities/${data.item.entity.entityType.code}/${data.item.entity.id}/`"
                                >
                                    {{ data.item.entity.title }}
                                </CLink>
                            </td>
                        </template>

                        <template #entity_product="data">
                            <td>
                                <CLink
                                    :to="`/entities/${data.item.entity.entityType.code}/${data.item.entity.id}/products/${data.item.entity_product.id}`"
                                >
                                    {{
                                        data.item.entity_product_title
                                            ? data.item.entity_product_title
                                            : data.item.entity_product.title
                                    }}
                                </CLink>
                            </td>
                        </template>

                        <template #entity_product_price="data">
                            <td>{{ +data.item.entity_product_price }} р.</td>
                        </template>

                        <template #variants="data">
                            <td>
                                <span
                                    v-for="variant in data.item.entity_variants"
                                    :key="variant.title"
                                >
                                    {{ variant.title }} -
                                    {{ variant.price }} р.<br />
                                </span>
                            </td>
                        </template>

                        <template #options="data">
                            <td>
                                <span
                                    v-for="option in data.item.entity_options"
                                    :key="option.title"
                                >
                                    {{ option.title }} -
                                    {{ option.price }} р.<br />
                                </span>
                            </td>
                        </template>

                        <template #sum_total="data">
                            <td class="blue">
                                {{ formatPrice((data.item.price * data.item.quantity) - data.item.refund_sum) }}
                            </td>
                        </template>

                        <template #refund_for="data">
                            <td>
                                {{
                                    data.item && data.item.refund_for
                                        ? ` За счет ${data.item.refund_for}${data.item.refund_comment ? ' ('+data.item.refund_comment+')' : ''} - ${ formatPrice(data.item.refund_sum) }`
                                        : ''
                                }}
                            </td>
                        </template>

                        <template #quantity="data">
                            <td>
                                {{ data.item.quantity }}
                            </td>
                        </template>

                        <template #edit="data">
                            <td>
                                <CButton
                                    v-if="data.item.entity_product_id"
                                    variant="ghost"
                                    color="primary"
                                    class="mb-1"
                                    @click="itemEdit(data.item)"
                                >
                                    <CIcon name="cil-pencil" /> </CButton
                                    ><br />
                                <CButton
                                    variant="ghost"
                                    color="danger"
                                    @click="itemDelete(data.item.id)"
                                >
                                    <CIcon name="cil-trash" />
                                </CButton>
                            </td>
                        </template>
                    </CDataTable>
                    <CRow>
                        <CCol class="form-group text-right">
                            <CButton
                                color="light"
                                class="ml-3"
                                @click="inactiveItemAdd"
                            >Добавить из неактивного</CButton>
                            <CButton
                                color="primary"
                                class="ml-3"
                                @click="itemAdd"
                            >Добавить товар</CButton
                            >
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol class="form-group">
                            <CButton
                                color="primary"
                                class="mr-3"
                                @click="orderUpdate"
                            >Сохранить</CButton
                            >
                            <CButton
                                color="light"
                                class="mr-3"
                                @click="$emit('cancel')"
                            >Отмена</CButton
                            >
                        </CCol>
                    </CRow>
                </CTab>
            </CTabs>
        </CCardBody>

        <OrderEDItemEdit
            :modal="itemEditModal"
            @update="itemUpdate"
            @cancel="itemCancel"
        />
        <OrderEDItemInactiveEdit
            :modal="inactiveItemEditModal"
            @update="inactivetemUpdate"
            @cancel="inactiveItemCancel"
        />
    </CCard>
</template>

<script>
    const { formatDate } = require('../../utils/views');
    import OrderEDItemEdit from './OrderEDItemEdit';
    import OrderEDItemInactiveEdit from './OrderEDItemInactiveEdit.vue';

    export default {
        name: 'OrderED',

        components: {
            OrderEDItemEdit,
            OrderEDItemInactiveEdit,
        },

        props: {
            order: {
                type: Object,
                default: () => ({}),
            },
            orderUnmodified: {
                type: Object,
                default: () => ({}),
            },
        },

        data() {
            return {
                isAuthorized: false,
                unmodifiedFields: [
                    {
                        key: 'entity',
                        label: 'Сервис',
                        _classes: 'font-weight-bold',
                    },
                    { key: 'entity_product', label: 'Товар' },
                    { key: 'variants', label: 'Варианты' },
                    { key: 'options', label: 'Опции' },
                    { key: 'quantity_total', label: 'Кол-во итог' },
                    { key: 'sum_total', label: 'Сумма итог' },
                    { key: 'price_total', label: 'Цена итог' },
                    { key: 'refund_for', label: 'Возврат' },
                    { key: 'quantity', label: 'Кол-во до' },
                    { key: 'sum', label: 'Сумма до' },
                    { key: 'price', label: 'Цена до' },
                ],
                fields: [
                    {
                        key: 'entity',
                        label: 'Сервис',
                        _classes: 'font-weight-bold',
                    },
                    { key: 'entity_product', label: 'Товар' },
                    { key: 'variants', label: 'Варианты' },
                    { key: 'options', label: 'Опции' },
                    { key: 'quantity', label: 'Кол-во' },
                    { key: 'refund_for', label: 'Возврат' },
                    { key: 'sum_total', label: 'Цена итоговая' },
                    { key: 'edit', label: '' },
                ],
                itemEditModal: {
                    item: {},
                    visible: false,
                    entityType: '',
                    emptyItem: {
                        entity: {},
                        entity_product: {},
                        entity_variants: [],
                        entity_options: [],
                        refund_for: '',
                        refund_comment: '',
                        price: 0,
                        quantity: 1,
                        enabled: true,
                        applyDiscount: true,
                        active: true,
                    },
                },
                inactiveItemEditModal: {
                    item: {},
                    visible: false,
                    entityType: '',
                    emptyItem: {
                        entity: {},
                        entity_product: {},
                        entity_variants: [],
                        entity_options: [],
                        refund_for: '',
                        refund_comment: '',
                        price: 0,
                        quantity: 1,
                        enabled: true,
                        applyDiscount: true,
                        inactive: true,
                    },
                },
            };
        },

        computed: {
            enabledItems() {
                return this.order.items ? this.order.items.filter(item => {
                    return item.enabled
                }) : [];
            },
            enabledUnmodifiedItems() {
                if(this.orderUnmodified.items) {
                    const orderItems = this.orderUnmodified.items.map(item => {
                        return {
                            ...item,
                            ...{
                            unique_id: item.entity_product_id + item.entity_variants.reduce((variant_unique, variant) => {
                                    return variant_unique + variant.id
                                }, '') + item.entity_options.reduce((option_unique, option) => {
                                    return option_unique + option.id
                                }, '')
                        }
                        }
                    });
                    const enabled = orderItems.map(item => {
                        return {
                            ...item,
                            price: +item.price,
                            old_price: +item.old_price,
                            quantity_total: item.quantity,
                            price_total: +item.price,
                            old_price_total: +item.old_price,
                            sum_total: item.sum,
                        }
                    }).filter(item => item.enabled);
                    const disabled = orderItems.filter(item => !item.enabled);
                    for(let i=0; i < enabled.length; i++) {
                        for(let j=0; j < disabled.length; j++) {
                            if(enabled[i].unique_id === disabled[j].unique_id && !disabled[j].checked) {
                                enabled[i].not_added = true;
                                enabled[i].quantity = disabled[j].quantity;
                                enabled[i].price = disabled[j].price;
                                enabled[i].old_price = disabled[j].old_price;
                                enabled[i].sum = disabled[j].sum;
                                disabled[j].not_removed = true;
                                disabled[j].checked = true;
                            }
                        }
                    }
                    for(let j=0; j < disabled.length; j++) {
                        if(!disabled[j].not_removed) {
                            disabled[j].not_added = true;
                            disabled[j].removed = true;
                            disabled[j].quantity_total = 0;
                            disabled[j].price_total = 0;
                            disabled[j].sum_total = 0;
                            enabled.push(disabled[j]);
                        }
                    }
                    for(let i=0; i < enabled.length; i++) {
                        if(!enabled[i].not_added) {
                            enabled[i].quantity = 0;
                            enabled[i].price = 0;
                            enabled[i].sum = 0;
                        }
                        enabled[i].sum = enabled[i].quantity * enabled[i].price;
                        enabled[i].sum_total = enabled[i].quantity_total * enabled[i].price_total - enabled[i].refund_sum;
                    }

                    return enabled;
                }
                return [];
            },
        },

        watch: {},

        mounted() {
            const label = this.order.items[0].entity.entityType.title;
            const filed = JSON.parse(JSON.stringify(this.fields[0]));
            this.fields.splice(0, 1, { ...filed, label });
        },

        methods: {
            formatDate(date) {
                return formatDate(date);
            },
            formatPrice(price) {
                return (Math.round(price * 100) / 100).toFixed(2) + 'р.';
            },
            itemAdd() {
                this.itemEditModal.item = { ...this.itemEditModal.emptyItem, isNewPosition: true };
                this.itemEditModal.entityType = this.order.items[0].entity.entityType.code;
                this.itemEditModal.visible = true;
            },
            inactiveItemAdd() {
                this.inactiveItemEditModal.item = { ...this.inactiveItemEditModal.emptyItem, isNewPosition: true };
                this.inactiveItemEditModal.entityType = this.order.items[0].entity.entityType.code;
                this.inactiveItemEditModal.visible = true;
            },
            itemEdit(item) {
                for (let i = 0; i < this.order.items.length; i++) {
                    if (this.order.items[i].id === item.id) {
                        if (item.active || item.entity_product.enabled === true) {
                            this.itemEditModal.item = JSON.parse(JSON.stringify(this.order.items[i]));
                            this.itemEditModal.visible = true;
                        }
                        if(item.inactive || item.entity_product.enabled === false) {
                            this.inactiveItemEditModal.item = JSON.parse(JSON.stringify(this.order.items[i]));
                            this.inactiveItemEditModal.visible = true;   
                        }
                    }
                }
            },
            itemDelete(id) {
                for (let i = 0; i < this.order.items.length; i++) {
                    if (this.order.items[i].id === id) {
                        this.order.items.splice(i, 1);
                    }
                }
            },
            itemUpdate() {
                let items = [];
                for (let i = 0; i < this.order.items.length; i++) {
                    if (this.order.items[i].id === this.itemEditModal.item.id) {
                        items.push(this.itemEditModal.item);
                    } else {
                        items.push(this.order.items[i]);
                    }
                }
                if (!this.itemEditModal.item.id) {
                    this.itemEditModal.item.id = 'temp-' + this.order.items.length;
                    items.push(JSON.parse(JSON.stringify(this.itemEditModal.item)));
                }
                this.order.items = items;
                this.itemCancel();
            },
            inactivetemUpdate() {
                let items = [];
                for (let i = 0; i < this.order.items.length; i++) {
                    if (this.order.items[i].id === this.inactiveItemEditModal.item.id) {
                        items.push(this.inactiveItemEditModal.item);
                    } else {
                        items.push(this.order.items[i]);
                    }
                }
                if (!this.inactiveItemEditModal.item.id) {
                    this.inactiveItemEditModal.item.id = 'temp-' + this.order.items.length;
                    items.push(JSON.parse(JSON.stringify(this.inactiveItemEditModal.item)));
                }
                this.order.items = items;
                this.inactiveItemCancel();
            },
            itemCancel() {
                this.itemEditModal.item = this.itemEditModal.emptyItem;
                this.itemEditModal.visible = false;
            },
            inactiveItemCancel() {
                this.inactiveItemEditModal.item = this.inactiveItemEditModal.emptyItem;
                this.inactiveItemEditModal.visible = false;
            },
            orderUpdate() {
                for (let i = 0; i < this.order.items.length; i++) {
                    if (this.order.items[i].id && this.order.items[i].id.toString().indexOf('temp-') >= 0) {
                        delete this.order.items[i].id;
                    }
                }
                this.$emit('update');
            },
        },
    };
</script>

<style>
.order-ed-card .table th,
.order-ed-card .table td {
    vertical-align: middle;
}
.order-ed-card .old-price {
    text-decoration: none;
    color: #a7a7a7;
}
.order-ed-card .green {
    /* color: #33d436 */
}
.order-ed-card .red {
    color: red
}
.order-ed-card .blue {
    color: blue;
}
</style>
